function wwGlobal() {
    $('a.ww-active').on('click', function(e) {
        e.preventDefault();

        buildWWGlobal().then(function() {
            // Set focus and force DOM reflow
            $('#ww-home').trigger('focus');
            $('#ddevents').fadeToggle(300);
        });
    });

    if (window.location.hash == '#worldwide') {
        $('a.ww-active').trigger('click');
    }
}

var buildWWGlobal = _.memoize(function() {
    // WorldWide Global DropDown
    return getEventsByType()
    .then(function(data) {
        var eventTypeOutput = '';
        $.each( data, function( eventTypeKey, eventType ) {
            var eventLogo = `<img src="${eventType.logo}" width="150" class="iblock logo vc mr10 mb25">`;

            if(eventType.url){
                eventLogo = `<a href="${eventType.url}">${eventLogo}</a>`;
            }

            eventTypeOutput +=
                `<div class="ddevent ww ${eventTypeKey}">
                    <div class="ddhead">
                        ${eventLogo}
                        <img src="${eventType.accent}" width="15" class="iblock accent vc  mb25">
                        <div class="lbreak3 op50"></div>
                    </div>
                    <ul>`;


            $.each(eventType.events, function (eventKey, event) {
                if (!event.visibility.overlay) {
                    return;
                }

                var link = event.url ? `<a class="rel" href="${event.url}">` : '<a class="rel">';

                var current_url = `${window.location.protocol}//${window.location.hostname}`;
                var active = '';
                if ((event.url == current_url)) {
                    active = 'class="active"';
                }

                eventTypeOutput += `<li id="ww-event-${event.code}" ${active}>${link}`;

                if (event.title) {
                    eventTypeOutput += `<em>${event.title}</em>`;
                }

                if (event.date.label) {
                    var date = event.date.label.replace("—", "&nbsp;/&nbsp;");
                    eventTypeOutput += `<i>&nbsp;&nbsp;&middot;&nbsp; ${date}</i> <img src="${event.media.flag || ultra_settings.images.default_flag}" class="flag" height="10">`;
                }

                eventTypeOutput += '</a><span class="lbreak3"></span></li>';
            });

            eventTypeOutput += '</ul></div>';
        });

        var wwGlobalOutput =
            `<div class="modal" id="ddevents" style="">
                <div class="eventsdd  md-content" data-style="display: table;">
                    <div class="inner">
                        <div class="w1200">
                            <a id="ww-home" tabindex="-1"></a>
                                ${eventTypeOutput}
                                <div class="wpf clear">
                                <div class="clear padt50"></div>
                                <div class="lbreak op50"></div>
                                <ul>
                                    <li><a href="https://umfworldwide.com" target="_blank"><img src="${ultra_settings.images.logos.ultra_worldwide}"></a></li>
                                    <li><a href="https://ultrapassport.com" target="_blank"><img src="${ultra_settings.images.logos.ultra_passport}"></a></li>
                                    <li><a href="https://umfworldwide.com/media/umf-films/" target="_blank"><img src="${ultra_settings.images.logos.umf_films}"></a></li>
                                    <li><a href="https://umfworldwide.com/media/umf-tv/" target="_blank"><img src="${ultra_settings.images.logos.umf_tv}"></a></li>
                                    <li><a href="https://www.mixcloud.com/umfradio" target="_blank"><img src="${ultra_settings.images.logos.umf_radio}"></a></li>
                                    <li><a href="https://umfworldwide.com/media/live" target="_blank"><img src="${ultra_settings.images.logos.ultra_live}"></a></li>
                                </ul>
                                <p class="text-center wpf">The World's Premier Electronic Music Festivals</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="md-bg"></div>    <button class="md-close"><i></i><b></b></button>
            </div>`;

        $('body').append(wwGlobalOutput);

        $('#ddevents .md-close').on('click', function(e){
            e.preventDefault();
            $(this).parent().fadeToggle(300);
        });

        //TODO: This may get bound multiple times, especially if it's defined by other modals.
        $(document).on("keyup", function (event) {
            if (event.keyCode == 27 && !! $('.md-close').length) {
                $('.md-close').trigger('click');
            }
        });
    });
});
